<template>
  <div class="e-card">
    <div class="e-title">
      <p>{{title}}</p>
      <p>{{label}}</p>
    </div>
    <div class="e-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ECard',
  props: {
    title: String,
    label: String
  }
}
</script>

<style lang="less" scoped>
  @import "../../index.less";

  .e-card {
    border: 1px solid @border-color;
    color: @font-color;
    .e-title {
      height: 40px;
      padding: 0 20px;
      line-height: 40px;
      font-size: 14px;
      background-color: @title-color;
      border-bottom: 1px solid @border-color;
      display: flex;
      justify-content: space-between;
    }
    .e-content {
      padding: 20px;
    }
  }
</style>
